import { render, staticRenderFns } from "./UserMemberChangeDetailDialog.vue?vue&type=template&id=3d0bbccc&scoped=true&lang=pug&"
import script from "./UserMemberChangeDetailDialog.vue?vue&type=script&lang=ts&"
export * from "./UserMemberChangeDetailDialog.vue?vue&type=script&lang=ts&"
import style0 from "./UserMemberChangeDetailDialog.vue?vue&type=style&index=0&id=3d0bbccc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0bbccc",
  null
  
)

export default component.exports